import { useContext } from 'react'

import { AstradaContext, AstradaContextValue } from './AstradaContext'

export default function useAstrada(): AstradaContextValue {
  const astrada = useContext(AstradaContext)

  return astrada
}
